import { ThirdNavChildrenType } from '../modules/ThirdNav/ThirdNav.controller';
import { useContext, useEffect } from 'react';
import { TopNavContext } from '../providers/TopNavProvider';

export const useThirdNavChildren = (children: ThirdNavChildrenType | undefined) => {
  const { dispatch } = useContext(TopNavContext);

  // IMPORTANT: Make sure "children" being passed in is memoized and not a new object every render.
  useEffect(() => {
    dispatch({ type: 'updateThirdNavChildren', payload: children });
  }, [children, dispatch]);

  useEffect(() => {
    return () => {
      dispatch({ type: 'updateThirdNavChildren', payload: undefined });
    };
  }, [dispatch]);
};
